import { render, staticRenderFns } from "./ScheduleTourPage4.vue?vue&type=template&id=0c60de37&"
import script from "./ScheduleTourPage4.vue?vue&type=script&lang=js&"
export * from "./ScheduleTourPage4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports